module.exports = __webpack_public_path__ + "static/media/emergency.70931794.svg";